<template>
  <Toast 
    class="s-toast"
    :pt="passTrough"
    :position="position"
    :group="group"
  >
    <template #messageicon="{severity} : any">
      <svg class="toast-message-icon" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
        <use :href="`#toast-${severity}-icon`"></use>
      </svg>
    </template>
    <template #closeicon>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <use href="#toast-close-icon"></use>
      </svg>
    </template>
  </Toast>
  <SvgSprite/>
</template>


<script setup lang="ts">
import Toast from 'primevue/toast';
import type { ToastProps } from 'primevue/toast';
import SvgSprite from './SvgSprite.vue';
import type { PropType } from 'vue'

type Position = "center" | "top-left" | "top-center" | "top-right" | "bottom-left" | "bottom-center" | "bottom-right"

defineProps({
  position: {
    type: String as PropType<Position>,
    default: "top-right"
  },
  group: {
    type: String as PropType<string | undefined>,
    default: undefined
  }
})

const passTrough =  {
  messageicon: ({ props }: {props: ToastProps}) => ({ severity: props.message?.severity ?? '' })
}

</script>



<style lang="scss">
.s-toast {
  --p-toast-width: auto;
  --p-toast-border-radius: 8px;
  --p-toast-border-width: 0px;
  --p-toast-icon-size: 24px;
  --p-toast-content-padding: 14px 12px;
  --p-toast-content-gap: 8px;
  --p-toast-detail-font-weight: 400;
  --p-toast-detail-font-size: 16px;
  --p-toast-close-button-height: 24px;

  --p-toast-success-background: #6DD22A;
  --p-toast-success-color: #fff;
  --p-toast-close-button-width: 24px;
  --p-toast-info-background: #2C50EE;
  --p-toast-info-color: #fff;
  --p-toast-warn-background: #FFD500;
  --p-toast-warn-color: #fff;
  --p-toast-error-background: #ED131C;
  --p-toast-error-color: #fff;

  &.p-toast-top-right .p-toast-message {
    width: fit-content;
    margin-left: auto;
  }

  .p-toast-message-content {
    align-items: center;
  }

  .p-toast-close-button {
    margin: 0;
    margin-left: 8px;
    right: 0;
  }

  .toast-message-icon {
    flex-shrink: 0;
  }
}
</style>